import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import About from '../About/About';
import { SEOHead, LocalBusinessSchema, BreadcrumbSchema } from '../SEO';

const AboutPage: React.FC = () => {
  const breadcrumbs = BreadcrumbSchema([
    { name: "Home", url: "/" },
    { name: "About Us", url: "/about" }
  ]);

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [LocalBusinessSchema, breadcrumbs]
  };

  return (
    <>
      <SEOHead
        title="About Maa Saryu Agency - 15+ Years Premium Tiles Supplier in Ayodhya | Our Story"
        description="Learn about Maa Saryu Agency - established tiles and sanitary ware supplier in Ayodhya with 15+ years experience. Our journey, values, and commitment to quality home solutions."
        keywords={[
          "about maa saryu agency",
          "tiles company ayodhya history",
          "established tiles supplier",
          "tiles business ayodhya",
          "sanitary ware company ayodhya",
          "tiles dealer ayodhya",
          "home improvement ayodhya",
          "quality tiles supplier",
          "trusted tiles dealer",
          "ayodhya tiles showroom"
        ]}
        canonicalUrl="/about"
        ogTitle="About Maa Saryu Agency - 15+ Years Premium Tiles Supplier in Ayodhya"
        ogDescription="Discover our 15+ years journey as Ayodhya's trusted tiles & sanitary ware supplier. Quality products, expert service, and customer satisfaction guaranteed."
        structuredData={structuredData}
      />
      <Box sx={{ py: 4 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 6, mt: 4 }}>
            <Typography variant="h2" component="h1" sx={{ 
              fontWeight: 'bold', 
              color: '#1a237e',
              mb: 2,
              fontSize: { xs: '2rem', md: '3rem' }
            }}>
              About Us
            </Typography>
            <Typography variant="h6" sx={{ 
              color: '#666',
              maxWidth: '600px',
              mx: 'auto',
              lineHeight: 1.6
            }}>
              Learn more about our mission, vision, and the team behind Maa Saryu Agency.
            </Typography>
          </Box>
        </Container>
        <About />
      </Box>
    </>
  );
};

export default AboutPage;
